import { defineCustomElement } from '@tyler-components-web/core';
import { TabBarComponent } from './tab-bar';
export * from './tab-bar-adapter';
export * from './tab-bar-constants';
export * from './tab-bar-foundation';
export * from './tab-bar';
export function defineTabBarComponent() {
    defineCustomElement(TabBarComponent);
}
